export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHUlEQVR42mNgYGD4TyEGEv//k4dHDRg1gLoGUIABTwHWOL0sKG8AAAAASUVORK5CYII="